import { Injectable } from '@angular/core';

import { HlsUtilService } from 'vbrick-player-src/HlsUtil.Service';
import { IVbSource } from 'vbrick-player-src/IVbSource';
import { NativePlaybackUtilService } from 'vbrick-player-src/NativePlaybackUtil.Service';
import { userAgentUtil } from 'vbrick-player-src/UserAgentUtil';

@Injectable()
export class VBrick360UtilService {
	private _isWebGLAvailable: boolean;

	constructor(
		private HlsUtilService: HlsUtilService,
		private NativePlaybackUtil: NativePlaybackUtilService
	) {}


	public is360PlaybackSupported(source: IVbSource): boolean {
		return !this.isUnsupportedBrowser() &&
			!this.HlsUtilService.isMixedContent(source.src) &&
			!this.isUnsupportedHls(source);
	}

	public isUnsupportedBrowser(): boolean {
		return userAgentUtil.isMobile ||
			userAgentUtil.isAndroidChrome ||
			!this.isWebGLAvailable();
	}

	public isUnsupportedHls(source: IVbSource): boolean { // HLS via Flash is not supported
		return this.HlsUtilService.isFlashFallback &&
			this.HlsUtilService.isHLS(source.src, source.type);
	}

	public isWebGLAvailable(): boolean {
		if (typeof this._isWebGLAvailable === 'undefined') {
			const canvas: HTMLCanvasElement = window.document.createElement('canvas');

			try {
				this._isWebGLAvailable = !!(window.WebGLRenderingContext &&
					(
						canvas.getContext('webgl') ||
						canvas.getContext('experimental-webgl')
					)
				);
			} catch (ex) {
				this._isWebGLAvailable = false;
			}
		}

		return this._isWebGLAvailable;
	}
}
